export default __webpack_public_path__ + "static/media/1726.92b201de.png";